module.exports = __webpack_public_path__ + "static/media/empieza-tu-tratamiento-moons.d572f644.webp";